"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const Tile_1 = __importDefault(require("./Tile"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  text-align: center;
  max-width: 1024px;
  margin: 0 auto;
  padding: 16px;
`;
const generateThumbnail = (tile) => {
    let thumbnail = "/images/other/placeholder.png";
    const tileType = Object.keys(tile)[0];
    const availableImages = tile[tileType].icon;
    if (availableImages &&
        Object.prototype.hasOwnProperty.call(availableImages, "1:1")) {
        thumbnail = availableImages["1:1"].M;
    }
    return thumbnail;
};
const BrandTiles = (props) => {
    const { history, location, updateStore } = props;
    const onTileClick = (tile) => {
        const type = Object.keys(tile)[0];
        updateStore("tileTitle", tile[type].title);
        switch (type) {
            case "venuesFolder":
                return history.push({
                    pathname: "/venues",
                    search: location.search,
                });
            default:
                return history.push({
                    pathname: `/directory/${type}/${tile[type].title.toLowerCase().replace(/ /g, "-")}`,
                    search: location.search,
                });
        }
    };
    const renderTiles = () => props.tiles.map((tile) => {
        const type = Object.keys(tile)[0];
        return (react_1.default.createElement(material_1.Grid, { key: (0, react_uid_1.uid)(tile), item: true, xs: 6, sm: 3, md: 3, onClick: () => onTileClick(tile) },
            react_1.default.createElement(Tile_1.default, { withCard: true, image: generateThumbnail(tile), title: tile[type].title, isRenderOnBrandLevel: true })));
    });
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, renderTiles())));
};
const mapStoreToProps = () => ({});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(BrandTiles));
